<aside
  [ngClass]="{ 'w-72': isExpanded(), 'w-16': !isExpanded() }"
  class="bg-white shadow-lg flex flex-col transition-all duration-300 h-full min-h-full relative"
  style="height: 100%; min-height: 100%"
>
  <ng-container
    *ngTemplateOutlet="isExpanded() ? openHeader : closeHeader"
  ></ng-container>
  <ng-template #openHeader>
    <div class="px-5 py-3 mb-[12px] flex items-center justify-center">
      <lib-icon
        [icon]="getIconName('SidebarLogo')"
        [category]="AssetsCategory.Sidebar"
        iconClass="h-11 min-[375px]:h-12 min-[425px]:h-14"
      ></lib-icon>
    </div>
  </ng-template>
  <ng-template #closeHeader>
    <div class="px-3 py-2 mb-[12px]">
      <lib-icon
        [icon]="getIconName('SidebarLogoClosed')"
        [category]="AssetsCategory.Sidebar"
      ></lib-icon>
    </div>
  </ng-template>

  <div
    class="flex-1 min-h-0 flex flex-col justify-start px-2 overflow-y-auto overflow-x-hidden"
  >
    @for (section of menuSections; track section.heading) {
    <div class="mb-1 flex-shrink-0 last:mb-0">
      @if(isExpanded()){
      <p class="text-xs text-neutral-light font-medium px-4 mb-1">
        {{ section.heading }}
      </p>
      }
      <ul class="space-y-1">
        @for (item of section.items; track item.route) {
        <li>
          <!-- Parent Menu Item -->
          <div
            [routerLink]="!hasChildren(item) || item.route ? item.route : null"
            [routerLinkActive]="
              !hasChildren(item) || item.route
                ? 'bg-primary-lightest text-primary font-medium'
                : ''
            "
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="handleItemClick(item, $event)"
            (keydown.enter)="handleItemClick(item, $event)"
            tabindex="0"
            class="flex py-[4px] items-center text-neutral-dark rounded-md hover:bg-gray-50 transition-colors cursor-pointer"
            [ngClass]="{
              'px-3': isExpanded(),
              'px-2 justify-center': !isExpanded()
            }"
          >
            @if(!isExpanded()){
            <lib-tooltip [text]="item.label" position="right" [useFixed]="true">
              <span
                class="w-8 h-8 flex items-center justify-center overflow-hidden cursor-pointer"
              >
                <lib-icon
                  [icon]="
                    getIconName(isExpanded() ? item.openIcon : item.closeIcon)
                  "
                  [category]="AssetsCategory.Sidebar"
                  class="cursor-pointer"
                  draggable="false"
                ></lib-icon>
              </span>
            </lib-tooltip>
            } @else {
            <span
              class="w-8 h-8 flex items-center justify-center overflow-hidden mr-2 cursor-pointer"
            >
              <lib-icon
                [icon]="
                  getIconName(isExpanded() ? item.openIcon : item.closeIcon)
                "
                [category]="AssetsCategory.Sidebar"
                class="cursor-pointer"
                draggable="false"
              ></lib-icon>
            </span>
            <span class="cursor-pointer font-roboto flex-1 truncate">{{
              item.label
            }}</span>
            @if(hasChildren(item)){
            <svg
              class="w-4 h-4 transition-transform duration-200"
              [ngClass]="{ 'rotate-180': !item.isExpanded }"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
            } }
          </div>

          <!-- Nested Children -->
          @if(hasChildren(item) && item.isExpanded && isExpanded()){
          <ul class="ml-11 mt-1 space-y-1">
            @for (child of item.children; track child.route) {
            <li
              [routerLink]="child.route"
              routerLinkActive="bg-primary-lightest text-primary font-medium"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="navigateToRoute(child.route)"
              (keydown.enter)="navigateToRoute(child.route)"
              tabindex="0"
              class="flex py-[4px] px-3 items-center text-neutral-dark text-sm rounded-md hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <span class="cursor-pointer font-roboto truncate">{{ child.label }}</span>
            </li>
            }
          </ul>
          }
        </li>
        }
      </ul>
    </div>
    }
  </div>

  <!-- Horizontal Separator Line -->
  <div class="h-px bg-gray-200 m-0 flex-shrink-0 w-full"></div>

  <!-- User Profile Section - Fixed at bottom, outside scrollable area -->
  <!-- TODO: REMOVE BG-IGNYTE-THEME-LIGHT -->
  <div class="flex-shrink-0 mt-0 p-4">
    @if(isExpanded()){
    <div
      class="flex items-center bg-ignyte-theme-light px-2.5 py-1.5 rounded-md"
    >
      <div
        class="flex flex-shrink-0 justify-center items-center w-9 h-9 bg-ignyte-theme text-white rounded-sm mr-3"
      >
        <span class="text-sm cursor-pointer font-bold">{{
          getInitials(displayName)
        }}</span>
      </div>
      <div class="flex flex-col justify-center min-w-0">
        <p
          class="text-sm font-medium text-gray-900 cursor-pointer leading-tight truncate"
          [title]="displayName"
        >
          {{ displayName }}
        </p>
        <!-- <p class="text-xs text-neutral-light leading-tight">Title</p> -->
      </div>
    </div>
    } @if(!isExpanded()){
    <div class="flex justify-center">
      <div
        class="flex justify-center items-center w-9 h-9 bg-ignyte-theme text-white rounded-sm"
      >
        <span class="text-sm cursor-pointer font-bold">{{
          getInitials(displayName)
        }}</span>
      </div>
    </div>
    } @else{
    <div
      class="flex justify-center items-center bg-creamish mt-3 p-1 rounded-md"
    >
      <button
        class="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-md cursor-pointer"
        (click)="handleSignOut()"
      >
        <lib-icon
          icon="LogoutIcon"
          [category]="AssetsCategory.Sidebar"
        ></lib-icon>
        <span class="text-neutral text-base">Sign Out</span>
      </button>
    </div>
    } @if(!isExpanded()){
    <lib-tooltip text="Sign Out" position="right" [useFixed]="true">
      <button
        (click)="handleSignOut()"
        class="mt-3 w-full flex justify-center bg-creamish items-center px-4.5 py-2.5 rounded-sm cursor-pointer"
      >
        <lib-icon
          icon="LogoutIcon"
          class="h-4 w-4"
          [category]="AssetsCategory.Sidebar"
        ></lib-icon>
      </button>
    </lib-tooltip>
    }
  </div>
</aside>
